/**
 * 创建人：但志强
 * 时间：2019-03-19
 * 描述：日历组件 
 * 使用说明: 参考 sw-simple-calendar 配置应用说明文档
 * 更新记录: 
 */
import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import SimpleCalendar from '../../../../../assets/Scripts/SimpleCalendar/javascripts/simple-calendar-es6.js'
import * as moment from 'moment';
declare var $;
/**
 * 日历组件   sw-simple-calendar
 */
@Component({
  selector: 'sw-simple-calendar',
  templateUrl: './sw-simple-calendar.component.html',
  styleUrls: ['./sw-simple-calendar.component.css']
})
export class SwSimpleCalendarComponent implements OnInit {

  /**
   * @ignore
   */
  constructor() { 
    this.calenderId = "calenderId" + Math.random().toString().split(".")[1];
  }

  /**
   * 日历id
   * @ignore
   */
  calenderId:string; 

  /**
   * 日历对象
   * @ignore
   */
  myCalender:any; 

  /**
   * 是否禁止切换年份
   */
  @Input() disabledYear :boolean = false

  /**
   * 是否禁止切换月份
   */
  @Input() disabledMonth :boolean = false

  /**
   * 点击某一天事件抛出
   */
  @Output() voted = new EventEmitter() 

  /**
   * 切换年份事件抛出
   */
  @Output() votedYear = new EventEmitter() 
  
  /**
  * 切换月份事件抛出
  */
 @Output() votedMonth = new EventEmitter() 
  
 /**
 * 点击返回今天事件抛出
 */
  @Output() votedToday = new EventEmitter() 

  /**
   * @ignore
   */
  ngOnInit() {
  }

  /**
   * 页面初始化方法
   * @ignore
   */
  ngAfterViewInit(): void {
    //初始化日历对象
    this.myCalender = new SimpleCalendar("#"+this.calenderId,{
      disabledYear:this.disabledYear,  //是否禁止切换年份
      disabledMonth:this.disabledMonth,  //是否禁止切换月份
    });
    //日历点击事件
    $(".sc-item").on('click',(event)=>{
      // event.currentTarget 是绑定事件的元素 , target是触发事件的元素
      if(event.currentTarget.classList.contains("sc-othermenth")){
        //如果是点击的禁用的日期,就不抛出
        return
      } else {
        //要使用定时器在dom元素中的值发生改变之后,将改变后的值抛出
        setTimeout(() => {
          let date = this.myCalender.getSelectedDay()
          this.voted.next(date)
        }, 0);
      }
    })

    //点击年份的左边切换
    $(".sc-yleft").on('click',(event)=>{
      //要使用定时器在dom元素中的值发生改变之后,将改变后的值抛出
      setTimeout(() => {
        let year = $(".sc-select-year")[0]["value"]
        this.votedYear.emit(year)
      }, 0);
    })

    //点击年份的右边切换
    $(this.myCalender.container.querySelector('.sc-yright')).on('click',(event)=>{
      //要使用定时器在dom元素中的值发生改变之后,将改变后的值抛出
      setTimeout(() => {
        let year = $(".sc-select-year")[0]["value"]
        this.votedYear.emit(year)
      }, 0);
      
    })

    //点击月份的左边切换
    $(".sc-mleft").on('click',(event)=>{
      //要使用定时器在dom元素中的值发生改变之后,将改变后的值抛出
      setTimeout(() => {
        let month = $(".sc-select-month")[0]["value"]
        this.votedMonth.emit(month)
      }, 0);
      
    })

    //点击月份的右边切换
    $(".sc-mright").on('click',(event)=>{
      //要使用定时器在dom元素中的值发生改变之后,将改变后的值抛出
      setTimeout(() => {
        let month = $(".sc-select-month")[0]["value"]
        this.votedMonth.emit(month)
      }, 0);
      
    })

    //点击月份的右边切换
    $(".sc-return-today ").on('click',(event)=>{
      //直接获取当天的时间转化为 'YYYY-MM-DD' 格式抛出
      let today = moment(new Date()).format('YYYY-MM-DD');
      this.votedToday.emit(today)
    })
  }


  //修改日历大小
  updateSize(width:string,height:string){
    this.myCalender.updateSize(width,height)
  }

  /**
   * 设置是否显示节日
   * @param br  是否开启 true 或者 false
   */ 
  showFestival(br:boolean){
    this.myCalender.showFestival(br)
  }

  /**
   * 设置是否显示假期
   * @param br 是否开启 true 或者 false
   */
  showHoliday(br:boolean){
    this.myCalender.showHoliday(br)
  }

  /**
   * 设置是否显示节气
   * @param br  是否开启 true 或者 false
   */
  showSolarTerm(br:boolean){
    this.myCalender.showSolarTerm(br)
  }

  /**
   * 设置是否显示阴历节日
   * @param br  是否开启 true 或者 false
   */
  showLunarFestival(br:boolean){
    this.myCalender.showLunarFestival(br)
  }

  /**
   * 设置是否显示阴历日期
   * @param br 是否开启 true 或者 false
   */
  showLunarCalendar(br:boolean){
    this.myCalender.showLunarCalendar(br)
  }

  /**
   * 设置是否显示标记日期
   * @param br 是否开启 true 或者 false
   */
  showMark(br:boolean){
    this.myCalender.showMark(br)
  }

  /**
   * 设置特殊日期 
   * @param Mark [{date:"2019-10-1",text:'放假'}] , 其中text可以是 html , '<p>有票</p>'
   */
  addMark(Mark:Array<any>){
    Mark.forEach(data=>{
      this.myCalender.addMark(data["date"],data["text"]);
    })
  }

  
}
